import { Container, Fab, Modal, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useThemeContext } from '../../../hook/useThemeManager';
import { isEmpty, isEqual } from '../../../utils/lodash';
import AddIcon from '@mui/icons-material/Add';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { theme } from '../../../constants/theme';
import { EmailImageTabs } from './EmailImageTabs';
import { EmailImageTab } from './EmailImageTab';

interface IContestEmailImageSelector {
    onChange?: (selection?: string) => void;
    maxSelection?: number;
    minSelection?: number;
    label?: string;
    overallStyle?: React.CSSProperties;
    options: string;
    /** Initial Value of the selected contest */
    value?: string;
    emailImages?: string[];
}

const ContestEmailImageSelector: React.FC<IContestEmailImageSelector> = ({
    label,
    onChange,
    value,
    options,
    emailImages,
}) => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<string | undefined>();
    const { themeStyle } = useThemeContext();

    const onHandleModal = () => {
        setOpen(!open);
    };

    useEffect(() => {
        if (value) {
            setSelected(value);
        }
    }, [value]);

    const handleDelete = () => {
        setSelected(undefined);
        onChange && onChange(undefined);
    };

    const handleOnSubmit = (EmailImage?: string) => {
        onChange && onChange(EmailImage);
        onHandleModal();
    };
    return (
        <Container disableGutters style={{ gap: '20px' }}>
            <Modal
                open={open}
                onClose={onHandleModal}
                style={{
                    backdropFilter: 'blur(12px)', // Adjust the blur level
                    backgroundColor: theme[themeStyle].background_gradient.end,
                    display: 'flex',
                    zIndex: 10100,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                slotProps={{
                    backdrop: {
                        timeout: 600,
                    },
                }}>
                <>
                    <EmailImageTabs
                        onClickButton={handleOnSubmit}
                        onClose={onHandleModal}
                        initialValue={selected}
                        step={{
                            displayTitle: 'Select your preferred Email Image',
                            options: options,
                        }}
                        themeStyle={themeStyle}
                        buttonText={isEmpty(selected) || isEqual(value, selected) ? 'close' : 'Submit'}
                        onChange={handleOnSubmit}
                        shouldShowButton
                        emailImages={emailImages}
                    />
                </>
            </Modal>
            <Typography
                style={{
                    fontFamily: FONT_ENUM.MEDIUM_HEADER,
                    color: theme[themeStyle].tag_white,
                    fontSize: 15,
                    marginBottom: '20px',
                }}>
                {label}
            </Typography>

            <Stack direction="row" spacing={1} alignItems="center">
                {!!selected && (
                    <EmailImageTab emailImage={selected} isActive={false} readOnlyMode onClickRemove={handleDelete} />
                )}

                {!selected && (
                    <Fab size="small" onClick={onHandleModal}>
                        <AddIcon />
                    </Fab>
                )}
            </Stack>
        </Container>
    );
};

export { ContestEmailImageSelector };
